/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'underscore'
], function(View, $, _) {



	var SubView = null;

	/**
	 * Wraps any arbitrary view that you want to add to the toolbar view
	 */
	SubView = View.extend({
		baseClass: 'toolbar',

		/**
		 * Creates a Arbitrary item
		 *
		 * @param spec -
		 *            The menu item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 * @param toolbar -
		 * 			  A reference to the toobar
		 */
		init: function(spec, root, toolbar) {
			_.extend(this, spec);
			SubView.inherited('init', this, arguments);
			this.subView.onUpdate = toolbar ? toolbar.hide.bind(toolbar) : null;
			this.subView.callbackClose = toolbar && toolbar.closeFlyout ? toolbar.closeFlyout.bind(toolbar) : null;
			this.toolbar = toolbar;
		},

		/**
		* Draws the SubView
		*/
		render: function() {
			this.$el
				.empty()
				.addClass(this.baseClass + 'InactiveItem');

			var promise = this.subView.render();

			// TODO: this is a hack. please refactor and have a more clear behaviour in this case.
			if(!promise || !promise.then){
				promise = Promise.resolve();
			}

			return promise.then(() => {
				this.$el.html(this.subView.$el);
				if (this.style){
					this.$el.addClass(this.style);
				}
			});
		},

		remove: function() {
			this.subView.remove();
			SubView.inherited('remove', this, arguments);
		},

		onFlyoutDestroyed: function() {
			if (this.subView.onFlyoutDestroyed) {
				this.subView.onFlyoutDestroyed();
			}
		},

		notifyRenderComplete: function() {
			if (this.subView.notifyRenderComplete) {
				this.subView.notifyRenderComplete();
			}
		},
		setFocus:function(){
			if (this.subView && this.subView.setFocus) {
				this.subView.setFocus();
			} else if (this.toolbar.goToPreviousEnabled) { //Back button enabled, and no view setFocus is present. Add a default behavior of setting the focus on the back button.
				this.toolbar.focusGoPrevious();
			}
		}
	});

	return SubView;
});
